import { render, staticRenderFns } from "./PropertyFilter.vue?vue&type=template&id=3dd6d6f2&scoped=true"
import script from "./PropertyFilter.vue?vue&type=script&lang=ts"
export * from "./PropertyFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6d6f2",
  null
  
)

export default component.exports